/**
 * Nested sidenav child that can target a route and optional fragment.
 */
export interface PlatformSidenavSubItem {
  labelKey: string;
  routerLink?: string | readonly string[];
  fragment?: string;
}

/**
 * Normalizes a routerLink value to a path starting with `/`.
 * @param link - String or command array
 * @returns Path without query or hash
 */
export function normalizeSidenavLink(link: string | readonly string[]): string {
  if (typeof link === 'string') {
    const trimmed = link.replace(/\/+$/, '');
    return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  }
  const joined = link
    .map(String)
    .map((part) => part.replace(/^\/+|\/+$/g, ''))
    .filter((part) => part.length > 0)
    .join('/');
  return `/${joined}`;
}
